import React from 'react';
import s from './About.module.scss';
import { useTranslation } from 'react-i18next';

interface AboutProps {
    data: any;
}

const About: React.FC<AboutProps> = ({ data }) => {
    const { t } = useTranslation() as any;

    return (
        <div className={s.container}>
            {/* Bio */}
            {data?.full_bio && (
                <div className={s.section}>
                    <p className={s.text}>{data.full_bio}</p>
                </div>
            )}

            {/* Contact Info */}
            <div className={s.section}>
                <h3 className={s.title}>{t('Contact Information')}</h3>

                {data?.phone && (
                    <div className={s.item}>
                        <span className={s.label}>{t('Phone')}:</span>
                        <a href={`tel:${data.phone}`} className={s.value}>{data.phone}</a>
                    </div>
                )}

                {data?.email && (
                    <div className={s.item}>
                        <span className={s.label}>{t('Email')}:</span>
                        <a href={`mailto:${data.email}`} className={s.value}>{data.email}</a>
                    </div>
                )}

                {data?.website && (
                    <div className={s.item}>
                        <span className={s.label}>{t('Website')}:</span>
                        <a href={data.website} target="_blank" rel="noopener noreferrer" className={s.value}>
                            {data.website}
                        </a>
                    </div>
                )}

                {data?.full_address && (
                    <div className={s.item}>
                        <span className={s.label}>{t('Address')}:</span>
                        <span className={s.value}>{data.full_address}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default About;